import { GlFilteredSearchToken, GlFilteredSearchSuggestion, GlIcon } from '../../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
export default {
    name: 'JobStatusToken',
    components: {
        GlFilteredSearchToken,
        GlFilteredSearchSuggestion,
        GlIcon
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        config: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        }
    },
    computed: {
        statuses () {
            return [
                {
                    class: 'ci-status-icon-canceled',
                    icon: 'status_canceled',
                    text: s__('Job|Canceled'),
                    value: 'CANCELED'
                },
                {
                    class: 'ci-status-icon-created',
                    icon: 'status_created',
                    text: s__('Job|Created'),
                    value: 'CREATED'
                },
                {
                    class: 'ci-status-icon-failed',
                    icon: 'status_failed',
                    text: s__('Job|Failed'),
                    value: 'FAILED'
                },
                {
                    class: 'ci-status-icon-manual',
                    icon: 'status_manual',
                    text: s__('Job|Manual'),
                    value: 'MANUAL'
                },
                {
                    class: 'ci-status-icon-success',
                    icon: 'status_success',
                    text: s__('Job|Passed'),
                    value: 'SUCCESS'
                },
                {
                    class: 'ci-status-icon-pending',
                    icon: 'status_pending',
                    text: s__('Job|Pending'),
                    value: 'PENDING'
                },
                {
                    class: 'ci-status-icon-preparing',
                    icon: 'status_preparing',
                    text: s__('Job|Preparing'),
                    value: 'PREPARING'
                },
                {
                    class: 'ci-status-icon-running',
                    icon: 'status_running',
                    text: s__('Job|Running'),
                    value: 'RUNNING'
                },
                {
                    class: 'ci-status-icon-scheduled',
                    icon: 'status_scheduled',
                    text: s__('Job|Scheduled'),
                    value: 'SCHEDULED'
                },
                {
                    class: 'ci-status-icon-skipped',
                    icon: 'status_skipped',
                    text: s__('Job|Skipped'),
                    value: 'SKIPPED'
                },
                {
                    class: 'ci-status-icon-waiting-for-resource',
                    icon: 'status-waiting',
                    text: s__('Job|Waiting for resource'),
                    value: 'WAITING_FOR_RESOURCE'
                }
            ];
        },
        findActiveStatus () {
            return this.statuses.find((status)=>status.value === this.value.data);
        }
    }
};
